var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMetric = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  fillRule: "evenodd",
  clipRule: "evenodd",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14 14.5a1.5 1.5 0 0 0 1.302-2.244l-6-10.5a1.5 1.5 0 0 0-2.604 0l-6 10.5A1.5 1.5 0 0 0 2 14.5zM12.111 13 8 10.362 3.888 13zm1.374-.9L8.75 3.812v5.249zM7.25 3.813l-4.735 8.286L7.25 9.061z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgMetric);
export default ForwardRef;